import { IApplicationState } from '../../../../types/redux';

export function priceGteSelector(state: IApplicationState): number | undefined {
  return state.filters.jsonQuery.price?.value.gte;
}
